import React from 'react';
import PropTypes from 'prop-types';
import activityServiceShape from 'services/types/activityService';
import annotationServiceShape from 'services/types/annotationService';
import scenarioServiceShape from 'services/types/scenarioService';
import pluginServiceShape from 'services/types/pluginService';
import templateServiceShape from 'services/types/templateService';
import interactiveServiceShape from 'services/types/interactiveService';
import pathwayServiceShape from 'services/types/pathwayService';
import componentServiceShape from 'services/types/componentService';
import projectServiceShape from 'services/types/projectService';
import scopeServiceShape from 'services/types/scopeService';
import themeServiceShape from 'services/types/themeService';
import favoritesServiceShape from 'services/types/favoritesService';
import recentServiceShape from 'services/types/recentService';

const ServicesContext = React.createContext();
const { Provider, Consumer } = ServicesContext;

/**
 * A React context which grants access to many persistent services, which
 * are contextually relevant throughout the application's session.
 * @param {*} props
 */
const ServicesProvider = ({
  activityService,
  annotationService,
  favoritesService,
  recentService,
  scenarioService,
  pluginService,
  templateService,
  pathwayService,
  interactiveService,
  componentService,
  projectService,
  scopeService,
  themeService,
  aiSummaryService,
  children,
}) => (
  <Provider
    value={{
      activityService,
      annotationService,
      favoritesService,
      recentService,
      scenarioService,
      pluginService,
      templateService,
      pathwayService,
      interactiveService,
      componentService,
      projectService,
      scopeService,
      themeService,
      aiSummaryService,
    }}
  >
    { children }
  </Provider>
);

ServicesProvider.propTypes = {
  activityService: activityServiceShape,
  annotationService: annotationServiceShape,
  scenarioService: scenarioServiceShape,
  favoritesService: favoritesServiceShape,
  recentService: recentServiceShape,
  pluginService: pluginServiceShape,
  templateService: templateServiceShape,
  interactiveService: interactiveServiceShape,
  pathwayService: pathwayServiceShape,
  componentService: componentServiceShape,
  projectService: projectServiceShape,
  scopeService: scopeServiceShape,
  themeService: themeServiceShape,
  children: PropTypes.any,
};

export function useServices() {
  return React.useContext(ServicesContext);
}

export { ServicesProvider };
export { Consumer as ServicesConsumer };
